import { useState } from 'react';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LaunchIcon from '@material-ui/icons/Launch';
import { experiences } from '../../portfolio';
import ScrollReveal from '../ScrollReveal/ScrollReveal';
import './Experiences.css';

const ExperienceContainer = ({ experience }) => {
  const {
    company,
    logo,
    color,
    type,
    position,
    dates,
    resposibilities = [],
    description,
    address,
    link,
    skills = [],
    externalLinks = [],
  } = experience;

  const [expanded, setExpanded] = useState(false);
  const hasLongBullets =
    resposibilities.join(' ').length > 280 || resposibilities.length > 2;
  const visibleBullets =
    expanded || !hasLongBullets
      ? resposibilities
      : resposibilities.slice(0, 2);

  return (
    <div className='experience-card glass-card'>
      <div
        className='experience-banner'
        style={{ background: color || 'rgb(20, 124, 244)' }}
      >
        <div className='experience-blurred_div' />
        {type && <span className='experience-badge'>{type}</span>}
        <div className='experience-div-company'>
          <h5 className='experience-text-company'>{company}</h5>
        </div>
        <a href={link} target='_blank' rel='noreferrer'>
          <img
            alt='Company logo'
            className='experience-roundedimg'
            src={logo}
          />
        </a>
      </div>
      <div className='experience-text-details'>
        <h5 className='experience-text-role'>{position}</h5>
        <h5 className='experience-text-date'>{dates}</h5>
        {address && (
          <div className='experience__address'>
            <LocationOnIcon />
            <span>{address}</span>
          </div>
        )}

        {description && (
          <p className='experience__summary'>{description}</p>
        )}

        {resposibilities.length > 0 && (
          <ul className='experience__bullets'>
            {visibleBullets.map((item) => (
              <li key={item.slice(0, 40)}>{item}</li>
            ))}
          </ul>
        )}

        {hasLongBullets && (
          <button
            type='button'
            className='experience__toggle'
            onClick={() => setExpanded(!expanded)}
            aria-expanded={expanded}
          >
            {expanded ? 'Show less' : 'Read more'}
            <ExpandMoreIcon
              className={`experience__toggle-icon ${
                expanded ? 'experience__toggle-icon--up' : ''
              }`}
            />
          </button>
        )}

        {externalLinks.length > 0 && (
          <div className='experience__links'>
            {externalLinks.map(({ label, url }) => (
              <a
                key={url}
                href={url}
                target='_blank'
                rel='noreferrer'
                className='experience__link-btn'
              >
                <LaunchIcon fontSize='small' />
                {label}
              </a>
            ))}
          </div>
        )}

        {skills.length > 0 && (
          <div className='experience__skill-tags'>
            {skills.map((skill) => (
              <span key={skill} className='experience__skill-tag'>
                {skill}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const Experiences = () => {
  if (!experiences.length) return null;

  return (
    <section id='experiences' className='section experiences'>
      <ScrollReveal>
        <h2 className='section__title'>Experience</h2>
      </ScrollReveal>
      <div className='experience-cards-div'>
        {experiences.map((experience, index) => (
          <ScrollReveal
            key={`${experience.company}-${experience.position}`}
            delay={index * 100}
          >
            <ExperienceContainer experience={experience} />
          </ScrollReveal>
        ))}
      </div>
    </section>
  );
};

export default Experiences;
